export default {"src":"/_next/static/media/0xef977d2f931c1978db5f6747666fa1eacb0d0339.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};